import React, { useContext } from 'react';
import PropTypes from 'prop-types';
const DEFAULT_MENU_CONTEXT = {
  disabled: false,
  isKeyboardNavigating: false,
  wrapWithLi: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerItem: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  unregisterItem: () => {}
};
const MenuContext = /*#__PURE__*/React.createContext(DEFAULT_MENU_CONTEXT);

const useMenuContext = () => useContext(MenuContext);

const MenuProvider = _ref => {
  let {
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: restProps
  }, children);
};

MenuProvider.defaultProps = DEFAULT_MENU_CONTEXT;
MenuProvider.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's']),
  mode: PropTypes.oneOf(['clear', 'classic', 'rock']),
  theme: PropTypes.oneOf(['light', 'dark']),
  disableCursor: PropTypes.bool,
  disabled: PropTypes.bool,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  itemTag: PropTypes.elementType
};
export { DEFAULT_MENU_CONTEXT, MenuContext, MenuProvider, useMenuContext };
